import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const RegistrationStepsWall = ({ children }) => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    let currentStep = params.get('steps');
    const recordedStep = useSelector(store => store?.registrationStates?.currentRegistrationStep);

    if (currentStep !== recordedStep) {
        return <Navigate to={'/auth/register?steps=' + recordedStep}  replace/>
    }
    return <>{children}</>;
}

export default RegistrationStepsWall;